// extracted by mini-css-extract-plugin
export default {"spacer":"SSSVgeELJkFNByK_pAHZ"};